export const Constants = {
  social: {
    facebook: "https://www.facebook.com/unlimitedhorizonssy?mibextid=ZbWKwL",
    telegram: "https://t.me/UnlimitedHorizon",
    instagram: "https://www.instagram.com/uh_unlimited.horizons?igsh=MTFqY3RueXZvODFmdg==",
    x: "https://x.com/Unlimitedhoriz",
    youtube: "https://youtube.com/@unlimitedhorizonsaccount?si=aAc0ll5uJ48f6gb-"
  },
};
